module.exports = __webpack_public_path__ + "static/img/cpzx_nav_2@2x.32314402.png";